import type { CurrentUser, PerfilActualizarInput, UsuarioPublic } from '@app/shared';

import { api, resolveApiUrl } from '../../../lib/api';

// Sprint 10 — Slice D — "Mi perfil". El frontend NUNCA habla con MinIO directo:
// el avatar se sube/baja siempre vía el backend.
export const perfilApi = {
  async actualizar(input: PerfilActualizarInput): Promise<{ usuario: UsuarioPublic }> {
    const { data } = await api.patch<{ usuario: UsuarioPublic }>('/usuarios/me', input);
    return data;
  },

  async subirAvatar(file: File): Promise<{ usuario: UsuarioPublic }> {
    const form = new FormData();
    form.append('avatar', file);
    const { data } = await api.post<{ usuario: UsuarioPublic }>('/usuarios/me/avatar', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  async quitarAvatar(): Promise<{ usuario: UsuarioPublic }> {
    const { data } = await api.delete<{ usuario: UsuarioPublic }>('/usuarios/me/avatar');
    return data;
  },
};

// La `avatarUrl` que devuelve /auth/me es relativa al API (ej. /usuarios/:id/avatar).
// La resolvemos contra el baseURL del cliente axios para usarla como src de <img>.
// Le agregamos un cache-buster opcional para forzar refresco tras subir/quitar.
export function resolveAvatarSrc(
  user: Pick<CurrentUser, 'avatarUrl'>,
  version?: string | number,
): string | null {
  const url = resolveApiUrl(user.avatarUrl);
  if (!url) return null;
  return version != null ? `${url}?v=${String(version)}` : url;
}
